/** Most Loan amounts and rates must be greater than 0 (like EditStdLoanModal's inputs); anything else is "no value". */
export const toPositiveNumber = (value: number | null | undefined): number | undefined =>
    value !== null && value !== undefined && !isNaN(value) && value > 0 ? value : undefined;
